<template>
  <div class="pagemain">
    <menu2 style="z-index: 999" page_name="项目发薪申请" back_type="close" back_icon="md-close"></menu2>

    <!-- <div class="head_box">
      <div class="head_left">
        <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />
        <span class="head_title">{{ project_name }} · 项目发薪申请（财务付款申请）</span>
      </div>
      <div class="head_right">
        <div class="record_head" @click="click_record">
          <Icon type="ios-archive" style="margin-right: 3px" size="22" />
          付款历史记录
        </div>
      </div>
    </div> -->

    <div class="faxin_div">

      <div class="faxin_div1">
        <div style="height: 40px"></div>
        <div class="record_options">
          <div class="options_title">{{ project_name }}发薪申请</div>
          <div class="record_head" @click="click_record">
            <Icon type="ios-archive" style="margin-right: 3px" size="22" />
            付款历史记录
          </div>
        </div>
        <div class="input_div">
          <div class="input_name"><span>*</span>项目名称</div>
          <div>
            <Input v-model="project_name" disabled placeholder="项目名称..." />
          </div>
        </div>
        <div class="input_div">
          <div class="input_name"><span>*</span>付款事由</div>
          <div>
            <Select v-model="payment_cause_id" placeholder="请选择付款事由...">
              <Option :disabled="item.disabled" v-for="item in cause_options" :value="item.value" :key="item.value">{{
                item.label }}</Option>
            </Select>
          </div>
          <!-- <div>
        <Input  maxlength="120"  v-model="cause" placeholder="请输入付款原因，例：工资款等." />
      </div> -->
        </div>
        <div class="input_div">
          <div class="input_name"><span>*</span>付款事由详情</div>
          <div>
            <Input maxlength="120" v-model="cause" placeholder="例：xx项目202403月工资款等." />
          </div>
        </div>
        <div class="input_div">
          <div class="input_name"><span>*</span>付款方式 <span
              style="font-weight: 300;font-size: 12px;color:#ccc;margin-left:10px">请正确选择，新增薪太软充值选项</span></div>
          <div>
            <Select v-model="payment_type_id" placeholder="请选择付款方式" @on-change="payment_type_change">
              <Option :disabled="item.disabled" v-for="item in payment_options" :value="item.value" :key="item.value">{{
                item.label }}</Option>
            </Select>
          </div>
        </div>
        <div class="input_div" style="padding-bottom: 10px; margin-bottom: 8px">
          <div class="input_name"><span>*</span>发薪主体</div>
          <div>
            <Cascader style="width: 100%" placeholder="请先选择付款方式后，再选择发薪主体" :data="bank_options" v-model="bank_select" />
          </div>
        </div>

        <div class="input_div">
          <div class="input_name"><span>*</span>发放/充值-总金额</div>
          <div>
            <InputNumber :min="0" :step="1" v-model="total_money" style="width: 250px" />
            <span>&nbsp;元</span>
          </div>
        </div>

        <div class="input_div">
          <div class="input_name">
            <span>*</span>业务所属月份<span class="yewu_txt">（业务真实发生的所属期,例如：厂里8月份的数据，不管当前是9月、10月还是11月，归属年月还是按8月算）</span>
          </div>
          <div class="check_jiesuan_universal_main">


            <div v-if="jiesuan_universal_status == 0" class="check_jiesuan_universal">
              <Icon type="ios-bulb-outline" size="18" color="red" />&nbsp;检测到{{ project_name }}【{{
                jiesuan_universal_year
              }}/{{ jiesuan_universal_month }}】没有结算(开票)记录，请修改开票结算归属月; 如果确实没有，请忽略提示。

            </div>
            <div v-else class="check_jiesuan_universal2">
              <Icon type="ios-bulb-outline" size="18" color="red" />&nbsp;检测到{{ project_name }}【{{
                jiesuan_universal_year
              }}/{{ jiesuan_universal_month }}】存在{{ jiesuan_universal_status }}条结算(开票 )数据。

            </div>
          </div>

          <!-- {{ jiesuan_year_month_status }}-{{ ownership_date }} -->
          <div class="jiesuan_select">
            <RadioGroup v-model="jiesuan_year_month_status" @on-change="radio_group_change">
              <Radio label="j1">
                <span class="jiesuan_txt">结算上个月{{ shangyue() }}</span>
              </Radio>
              <Radio label="j2">
                <span class="jiesuan_txt">结算本月{{ benyue() }}</span>
              </Radio>
              <Radio label="j3">
                <span class="jiesuan_txt">结算其他月份</span>
              </Radio>
            </RadioGroup>
            <DatePicker @on-change="date_picker_change" v-if="jiesuan_year_month_status == 'j3'"
              v-model="ownership_date" type="month" size="small" placeholder="请选择年月" style="width: 250px" />
          </div>
        </div>

        <div class="input_div">
          <div class="input_name"><span>*</span>支付条件</div>
          <div>
            <Select v-model="condition_id" style="width: 250px" @on-change="zhifu_change">
              <Option :disabled="item.disabled" v-for="item in condition_options" :value="item.value" :key="item.value">
                {{
                  item.label }}</Option>
            </Select>
          </div>
        </div>

        <div class="input_div" v-if="condition_id == 'C1'">
          <div class="input_name">
            <span>*</span>关联项目回款数据（重要提示：没有回款可不勾选，有回款必须要勾选）
          </div>
          <Table @on-selection-change="relevance_selection_change" size="small" height="200"
            :columns="relevance_columns" :data="relevance_table_data"></Table>
        </div>
        <div class="input_div" v-if="condition_id == 'C3'">
          <div class="input_name">
            <span>*</span>关联项目开票数据（重要提示：没有开票可不勾选，有开票必须要勾选）
          </div>
          <Table @on-selection-change="relevance_selection_invoice_change" size="small" height="200"
            :columns="relevance_invoice_columns" :data="relevance_invoice_table_data"></Table>
        </div>
        <div class="input_div" v-if="condition_id == 'C2'">
          <div class="input_name"><span>*</span>对应月份（预估结算）开票金额</div>
          <div>
            <InputNumber :min="0" :step="1" v-model="invoice_money" style="width: 250px" />
            <span>&nbsp;元</span>
          </div>
        </div>

        <div class="input_div" style="padding-bottom: 10px">
          <div class="input_name"><span>*</span>支付日期</div>
          <div>
            <DatePicker @on-change="pay_date_change" v-model="pay_date" type="date" placeholder="请选择支付日期"
              style="width: 250px" />
          </div>
        </div>

        <div class="input_div" style="margin-top: 8px" v-if="payment_type_id != 'T5'">
          <div class="input_name">
            <span>*</span>附件-发薪表
            <div class="faxin_btn_list">

              <div @click="bankcard_baobei_show = true" class="down_a">
                <Icon type="ios-cloud-upload-outline" />异常银行卡报备
              </div>
              <div @click="down_template()" class="down_a">
                <Icon type="md-arrow-down" />下载发薪表模板
              </div>
              <div @click="view_bank_card_info()" class="down_a">
                <Icon type="ios-cloud-circle" />银行卡开户行信息生成
              </div>
              <div @click="view_faxinweituo_file()" class="down_a">
                <Icon type="ios-eye" />薪资委托收款书模板下载
              </div>
              <div @click="weituo_jiaocheng()" class="down_a">
                <Icon type="ios-eye" />完善委托书教程
              </div>
            </div>
          </div>
          <div class="faxin_tishi">
            提示：为了保证发薪规范化，财务部要求：1、发薪【姓名、银行卡号、身份证号进行三要素校验，必须三要素是同一人；2、发薪表银行账号需与系统的默认工资卡对应
          </div>
          <div class="img_div_main">
            <div class="excel_div" v-if="JSON.stringify(faxin_file) != '{}'">
              <span class="iconfont iconExcel"></span>
              <div style="margin-left: 10px">
                <span>{{ faxin_file.filename }}</span>
                <span @click="view_file(faxin_file.object_name)" style="margin-left: 30px" class="down_upload_file"
                  title="查看文件">
                  <Icon size="18" type="md-eye" />
                </span>
                <span @click="del_faxin_file()" style="margin-left: 10px" class="down_upload_file" title="删除">
                  <Icon type="md-trash" color="red" size="18" />
                </span>
                <span @click="down_file2(faxin_file.url)" style="margin-left: 10px" class="down_upload_file"
                  title="下载文件">
                  <Icon size="18" type="md-download" color="blue" />
                </span>
              </div>
            </div>
            <Button v-if="JSON.stringify(faxin_file) != '{}'" style="margin: 10px 10px"
              @click="show_faxin_jiezhi">自定义借支</Button>
          </div>
          <div>
            <Upload :show-upload-list="false" :action="upload_url_faxin + '&project_id=' + project_id"
              :on-success="upload_faxin_success" :before-upload="upload_before" ref="upload01" :on-error="upload_error">
              <Button :loading="upload_faxin_show" icon="ios-cloud-upload-outline" type="primary">上传发薪Excel文件</Button>
            </Upload>
          </div>
        </div>

        <!-- 
    <div class="input_div">
      <div class="input_name"><span></span>附件-回款截图</div>
      <div class="img_div_main">
        <div v-for="(item, i) in img_list" :key="i" class="img_div">
          <div @click="del_img(item, i)" class="close_div">
            <Icon color="#fff" type="md-close" />
          </div>
          <img
            @click="view_img(item.url)"
            :src="item.url"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
      <div>
        <Upload
          :show-upload-list="false"
          :action="upload_url_img"
          :on-success="upload_success"
        >
          <Button icon="ios-cloud-upload-outline" type="primary">上传图片</Button>
        </Upload>
      </div>
    </div> -->

        <div class="input_div">
          <div class="input_name"><span>*</span>附件-企业结算表等</div>
          <div class="img_div_main">
            <div v-for="(item, i) in file_list" :key="i" class="fujian_div">
              <div style="margin-left: 10px">
                <span>{{ item.filename }}</span>
                <span @click="view_file(item.object_name)" style="margin-left: 30px" class="down_upload_file"
                  title="查看文件">
                  <Icon size="18" type="md-eye" />
                </span>
                <span @click="del_file(item, i)" style="margin-left: 10px" class="down_upload_file" title="删除">
                  <Icon type="md-trash" color="red" size="18" />
                </span>
                <!-- <span
              @click="down_file2(item.url)"
              style="margin-left: 10px"
              class="down_upload_file"
              title="下载文件"
              ><Icon size="18" type="md-download" color="blue"
            /></span> -->
              </div>

              <!-- <div @click="view_file2(item, i)" class="down_div2" style="padding: 0 5px">
            <Icon color="#fff" type="md-eye" />
          </div>
          <div @click="del_file(item, i)" class="close_div">
            <Icon color="#fff" type="md-close" />
          </div>

          <img
            v-if="item.suffix == 'png'"
            @click="view_img(item.url)"
            :src="item.url"
            alt=""
            style="width: 100%; height: 100%"
          />
          <div v-else style="width: 100%; height: 100%" class="file_div">
            <div>{{ item.filename }} <span style="font-size: 12px"></span></div>
          </div> -->
            </div>
          </div>
          <div>
            <Upload :show-upload-list="false" :action="upload_url_file" :on-success="upload_file_success"
              ref="upload02">
              <Button icon="ios-cloud-upload-outline" type="primary">上传附件</Button>
            </Upload>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div class="tijiao">
          <Button type="primary" :loading="submit_loading" @click="click_submit">确认提交申请
          </Button>
        </div>
      </div>



    </div>

    <Modal v-model="teaching_show" title="功能教学" :mask-closable="false" :footer-hide="true" :closable="true" width="1000"
      @on-visible-change="teaching_change">
      <div class="teaching_modal">
        <iframe :src="tips_url" style="width:100%;height:calc(100% - 7px) " frameborder="0"></iframe>
      </div>

    </Modal>

    <!-- <Modal v-model="teaching_show" title="功能教学" :mask-closable="false" :footer-hide="true" :closable="true" width="85%">
      <div class="teaching_modal">
        <iframe :src="tips_url" style="width:100%;height:calc(100% - 7px) " frameborder="0"></iframe>
      </div>

    </Modal> -->

    <Modal v-model="submit_show" @on-ok="submit_ok" title="提交完成" :width="300" @on-cancel="submit_show = false">
      <p>提交成功，请勿多次提交！历史记录请点击右上角查看</p>
    </Modal>

    <Drawer title="借支核销勾选" :mask-closable="false" :closable="false" width="500px" v-model="jiezhi_hexiao_show">
      <div class="table_hexiao_div">
        <div v-for="(item, i, n) in jiezhi_hexiao_table_data" :key="i">
          <div class="jiezhi_title">
            <div class="index_span">{{ n + 1 }}</div>
            <div>
              {{ i }}
            </div>
          </div>

          <div v-if="item.length > 0">
            <div class="child_item_list" v-for="(child_item, child_index) in item" :key="child_index">
              <div class="checked_jiezhi">
                <div class="checked_jiezhi_box">
                  <Checkbox :disabled="child_item.disabled" v-model="child_item.checked"></Checkbox>
                </div>
                <span :style="child_item.disabled ? 'color:#ccc' : 'color:#000'">借支发放时间：{{ child_item.fafang_time
                }}</span>
                <span class="jiezhi_money">￥{{ child_item.money }}</span>
                <span class="xzy" v-if="!child_item.disabled">需注意</span>
              </div>
            </div>
          </div>
          <div v-else class="wujiezhi">无借支</div>
        </div>
      </div>
      <div class="tijiao2">
        <Button type="primary" @click="baocun_hexiao_btn">保存数据</Button>
      </div>
    </Drawer>
    <!-- <Modal
      v-model="jiezhi_hexiao_show"
      @on-ok="jiezhi_hexiao_ok"
      title="借支核销选择"
      :width="300"
      @on-cancel="jiezhi_hexiao_show = false"
    >
      <div>选择绑定的借支</div>
    </Modal> -->

    <Modal v-model="error_show" :mask-closable="false" :closable="true" title="操作警告" :footer-hide="true" :width="300">
      <p>
        页面数据加载异常，请关闭本页面，重新在项目详情中点击打开一次，否则可能数据填完后无法提交，影响体验。
      </p>
    </Modal>

    <Modal v-model="faxin_error_show" :mask-closable="false" :closable="true" title="数据异常提示" :footer-hide="true"
      :width="800">
      <div class="faxin_error_txt">{{ faxin_error_txt }}</div>
      <div>
        <div class="margin-bottom:10px;color:red">
          解决方案：如金额中小数点后很多0，表示金额小数失真，需要把excel中的单元格类型转为【文本型数字】即可。
          <br />
          如下图以wps为例,调整后还提示金额出错请及时联系管理员：
        </div>
        <div style="color: red">
          所有的带数字的单元格(金额、手机号、身份证号、银行卡号等)都应该是文本型的，单元格左上角有绿色小三角号就是文本型数字，没有则表示需要转换！
        </div>

        <div>
          <img class="faxin_error_img" src="@/assets/image/finance/faxinbiaoshuoming.jpg" />
        </div>
      </div>
    </Modal>

    <Modal v-model="faxin_error_list_show" :mask-closable="false" :closable="true" title="上传出错提示" :footer-hide="true"
      :width="800">
      <div>
        检测到下方问题，请查看后更改！三要素出错一般指：（姓名、身份证号、银行卡号
        ）实名不是同一个人，如提示无效卡号或卡状态异常，则可能是卡被限制或无效，尽量换一个卡号，如没有其他卡请跟收款人确认是否可正常收到钱后点击申诉。
      </div>
      <div class="faxin_error_list_div">
        <div v-for="(item, i) in faxin_error_list" :key="i" class="faxin_error_li">
          {{ i + 1 }}: {{ item.msg }}
          <span v-if="item.code == 440" class="shensu_msg" @click="shensu_bankcard(item)">点击报备异常卡></span>
        </div>
      </div>
    </Modal>
    <!-- <Modal v-model="faxin_show" title="发薪-默认工资卡功能调整的通知" :mask-closable="false" :footer-hide="true" width="500">
      <div>
        1、发薪前请检查并及时完善员工<span style="color:red">收款工资卡</span>
        ，可由驻厂自行完善，或引导员工到微信公众号【大湘员工服务中心】自行设置默认收款银行卡，收款工资卡未完善可能导致发薪失败或异常！
      </div>
      <div>
        2、为方便大家使用，员工如果一张工资卡都没有，系统会按发薪信息自动新增第一张，并配置为默认收款卡，无需操作。
      </div>
      <div>
        3、如果有多张收款卡，且此次的卡非默认收款卡，需要与员工沟通后手动配置，如一致则不影响提交。
      </div>

    </Modal> -->

    <Modal v-model="bankcard_baobei_show" :footer-hide="true" title="异常银行卡报备" :width="400">
      <div>
        发薪或添加银行卡出现的三要素异常银行卡，与员工核对后能正常收到款的可在此处报备。报备后正常操作即可。
      </div>
      <div class="bank_baobei_input_div">

        <div class="bank_baobei_input">
          <span>卡类型：</span>

        </div>
        <Select v-model="bankcard_baobei_item.card_type" style="width:200px">
          <Option value="yinhangka">银行卡</Option>
          <Option value="cunzhe">存折</Option>
        </Select>
        <div class="bank_baobei_input">
          <span>姓名：</span>
          <Input v-model="bankcard_baobei_item.name" placeholder="员工姓名" />
        </div>
        <div class="bank_baobei_input">
          <span>身份证号：</span>
          <Input v-model="bankcard_baobei_item.idcard" placeholder="身份证号码" />
        </div>
        <div class="bank_baobei_input">
          <span>银行卡号：</span>
          <Input v-model="bankcard_baobei_item.bankcard_number" placeholder="银行卡号" />
        </div>


      </div>
      <div style="display: flex;justify-content: end;margin-top:20px">
        <Button type="primary" @click="bankcard_baobei_ok">确认报备</Button>
      </div>
    </Modal>

    <Modal v-model="caiwu_code_show" title="提示" :mask-closable="false" :closable="false" :footer-hide="true"
      width="400">
      <div>
        <div>
          当前项目无法进行发薪。原因：{{ caiwu_code_show_msg }}。请联系财务[陈红]添加编码。🤙🤙🤙
        </div>

      </div>
    </Modal>


    <Modal v-model="question_show" :mask-closable="false" :closable="false" title="小测验" :footer-hide="true"
      :width="700">
      <div>
        为避免发薪数据填写错误，首次操作前需完成《发薪-理解测试》，全部答对后方可进入操作界面。
      </div>
      <div v-if="question_list.length > 0">
        <div class="question_content" v-if="question_result == 0">
          <div>
            <div class="question_number">
              第{{ question_index + 1 }}题（{{ question_current_item.type }}） / 共{{ question_list.length }}题
            </div>

            <div class="question_name">
              <span class="question_yc_tag">原创</span>{{ question_current_item.name }}
            </div>
            <div class="question_options_div">
              <div v-for="(item2, i2) in question_current_item.options" :key="i2" class="question_otpions_list "
                @click="click_question(item2, question_current_item)">
                <span v-if="question_current_item.analysis_status == 0" class="question_abc ">{{
                  question_abc_list[i2] }}</span>
                <span v-if="question_current_item.analysis_status > 0"
                  :class="item2.is_correct == 1 ? 'question_abc question_otpions_list_select' : 'question_abc question_otpions_list_select2'">{{
                    question_abc_list[i2] }}</span>
                <span>{{ item2.value }}</span>
              </div>
            </div>
            <div class="analysis_div" v-if="question_current_item.analysis_status > 0">
              <div class="analysis_result">{{ question_current_item.analysis_status == 1 ? '恭喜你，✔️答对了!' :
                '很可惜，❌答错了，您无法操作发薪!' }}
                <span v-if="question_current_item.analysis_status == 2" class="question_again"
                  @click="question_again(question_current_item, item2)">知错了，再试一次</span>
                <span v-if="question_current_item.analysis_status == 1" class="question_again"
                  @click="question_next(question_current_item, item2)">下一题&nbsp;></span>
              </div>
              <div class="question_jiexi"><span class="question_yc_tag">解析</span>{{ question_current_item.analysis }}
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="question_result_icon">
            <span class="iconfont iconwancheng2"></span>
          </div>
          <div class="question_result_txt">
            恭喜您，已经完成测试！在没有新题目出现之前，本测验不会再弹出。
          </div>
          <div class="quesion_result_btn">
            <Button type='primary' @click="close_question">确认关闭</Button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";
var Base64 = require("js-base64").Base64;
import menu2 from "@/component/menu/menu2.vue";

export default {
  name: "project_payment",
  components: {
    menu2,
  },
  data() {
    return {
      project_id: "",
      project_name: "",

      cause: "",

      bank_options: [],
      bank_select: [],

      payment_options: [],
      payment_type_id: "",
      payment_type_select_status: 0,
      payment_cause_id: "",

      total_money: 0,
      invoice_money: 0,
      ownership_date: "",
      jiesuan_year_month_status: "j1",

      pay_date: new Date(),

      condition_options: [],
      condition_id: "",

      upload_url_img:
        process.env.VUE_APP_HOST +
        "/finance/payment/upload_accessory?type=img&token=" +
        this.$cookies.get("dx_token"),
      upload_url_file:
        process.env.VUE_APP_HOST +
        "/finance/payment/upload_accessory?type=file&token=" +
        this.$cookies.get("dx_token"),
      upload_url_faxin:
        process.env.VUE_APP_HOST +
        "/finance/payment/upload_accessory?type=faxin&token=" +
        this.$cookies.get("dx_token"),

      img_list: [],
      file_list: [],
      faxin_file: {},

      submit_show: false,
      cause_options: [],

      relevance_table_data: [],
      relevance_columns: [],
      relevance_select_list: [],

      // 关联开票数据
      relevance_invoice_table_data: [],
      relevance_invoice_columns: [],
      relevance_invoice_select_list: [],

      // 借支核销
      jiezhi_hexiao_item: {},
      jiezhi_hexiao_show: false,
      jiezhi_hexiao_table_data: {},
      jiezhi_hexiao_columns: [],

      //
      error_show: false,
      // 发薪表金额出错提示
      faxin_error_show: false,
      faxin_error_txt: "",

      //提交加载等待
      submit_loading: false,
      //上传等待
      upload_faxin_show: false,

      faxin_error_list: [],
      faxin_error_list_show: false,
      faxin_show: true,
      teaching_show: true,
      tips_url: "https://doc.daxiangsys.com/share/q551qv8cqm/p/-bMO9izb8tY",

      bankcard_baobei_show: false,
      bankcard_baobei_item: {
        name: "",
        idcard: "",
        bankcard_number: '',
        card_type: 'yinhangka'
      },
      caiwu_code_show: false,
      caiwu_code_show_msg: "",
      question_show: false,
      question_list: [],
      question_current_item: {},
      question_index: 0,
      question_abc_list: ['A', 'B', 'C', 'D', 'E', 'F'],
      question_result: 0,
      question_show_status: false,
      // 统一结算数据
      jiesuan_universal_status: 0,
      jiesuan_universal_year: 0,
      jiesuan_universal_month: 0
    };
  },

  mounted() {
    var query = this.$route.query;
    if (query) {
      this.project_id = query.project_id;
      this.project_name = query.project_name;
      console.log(this.project_id);
      if (this.project_id == "") {
        this.error_show = true;
      }
    }
    this.get_project_caiwu_code();

    this.get_payment_type();
    this.get_cause_options();
    this.get_payment_condition();
    this.get_relevance_returned_data();
    this.get_relevance_invoice_data();
    this.get_querstion_data();

    this.get_jiesuan_universal_status();
  },

  methods: {

    radio_group_change() {
      this.get_jiesuan_universal_status()
    },

    date_picker_change(e) {
      console.log(e)
      const [year, month] = e.split("-").map(Number);

      console.log(year)
      console.log(month)
      // // 选择年月变化后的查询结算数据
      // if (Array.isArray(this.ownership_date)) {
      //   var year = this.ownership_date[0];
      //   var month = this.ownership_date[1];
      //   console.log(year, month)
      // }
      var that = this
      var obj = {
        project_id: this.project_id,
        year: year,
        month: month
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/get_jiesuan_universal_status",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res)
            that.jiesuan_universal_status = res.data.count
            that.jiesuan_universal_year = year
            if (month < 10) {
              that.jiesuan_universal_month = '0' + String(month)
            } else {
              that.jiesuan_universal_month = String(month)
            }

          } else {

          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });


    },

    get_jiesuan_universal_status() {
      const that = this
      console.log('查询--结算数据+----')
      if (this.jiesuan_year_month_status == "j1") {
        // 上月
        var currentDate = new Date();
        var currentMonth = currentDate.getMonth();
        var currentYear = currentDate.getFullYear();
        var prevMonth, prevYear;
        if (currentMonth === 0) {
          // 一月份情况
          prevMonth = 12;
          prevYear = currentYear - 1;
        } else {
          prevMonth = currentMonth;
          prevYear = currentYear;
        }

        var obj = {
          project_id: this.project_id,
          year: prevYear,
          month: prevMonth
        };
        http(
          "post",
          process.env.VUE_APP_HOST + "/finance/payment/get_jiesuan_universal_status",
          obj,
          true
        )
          .then((res) => {
            if (res.code == 0) {
              console.log(res)
              that.jiesuan_universal_status = res.data.count
              that.jiesuan_universal_year = prevYear
              if (prevMonth < 10) {
                that.jiesuan_universal_month = '0' + String(prevMonth)
              } else {
                that.jiesuan_universal_month = String(prevMonth)
              }
            } else {

            }
          })
          .catch((res) => {
            console.log(res, "请求出错");
          });

      }
      if (this.jiesuan_year_month_status == "j2") {
        // 本月

        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth() + 1;

        var obj = {
          project_id: this.project_id,
          year: year,
          month: month
        };
        http(
          "post",
          process.env.VUE_APP_HOST + "/finance/payment/get_jiesuan_universal_status",
          obj,
          true
        )
          .then((res) => {
            if (res.code == 0) {
              console.log(res)
              that.jiesuan_universal_status = res.data.count
              that.jiesuan_universal_year = year
              if (month < 10) {
                that.jiesuan_universal_month = '0' + String(month)
              } else {
                that.jiesuan_universal_month = String(month)
              }

            } else {

            }
          })
          .catch((res) => {
            console.log(res, "请求出错");
          });

      }



      // console.log(year_month)


    },


    question_submit() {
      console.log('获取选择题')
      var that = this;
      var question_id_list = []
      for (var i = 0; i < this.question_list.length; i++) {
        question_id_list.push(this.question_list[i]['question_id'])
      }
      var obj = {
        project_id: this.project_id,
        question_id_list: question_id_list
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/question/question_submit",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res)
          } else {

          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    close_question() {
      this.question_show = false
      this.question_submit();
    },

    question_next(item, item2) {
      if (this.question_index == this.question_list.length - 1) {
        this.question_result = 1
      } else {
        this.question_index += 1
        this.question_current_item = this.question_list[this.question_index]
      }

    },

    question_again(item, itme2) {
      item.analysis_status = 0;
    },

    click_question(item2, item) {
      console.log(item)
      console.log(item2)
      if (item.analysis_status > 0) {
        this.$Message.error('已经选择过了')
        return
      }
      if (item2.is_correct == 0) {
        item.analysis_status = 2
      } else {
        item.analysis_status = 1
      }

    },

    teaching_change(e) {
      console.log(e)
      if (e == false && this.question_show_status == true) {

        this.question_show = true
      }
    },

    get_querstion_data() {
      console.log('获取选择题')
      var that = this;
      var obj = {
        project_id: this.project_id,
        question_type: '发薪'
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/question/question_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res)
            that.question_index = 0
            that.question_list = res.data.question_list
            that.question_result = 0
            if (that.question_list.length > 0) {
              that.question_show_status = true
              that.question_current_item = that.question_list[that.question_index]

            }


          } else {


          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_project_caiwu_code() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/get_project_caiwu_code",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {

          } else {
            that.caiwu_code_show = true
            that.caiwu_code_show_msg = res.msg;

          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    shensu_bankcard(item) {
      console.log(item)
      var that = this;
      this.$Modal.confirm({
        title: "操作提示",
        content: "<p>系统检测这个卡不正常，可能卡号或状态有异常！<br>请再次确认当前卡号是否能正常使用收到款？并且跟员工二次确认<br> 如卡没问题请点【确认】不可以用点【取消】" + "</p>",
        onOk: () => {
          var obj = {
            verify_id: item.data.verify_id,
          };
          http(
            "post",
            process.env.VUE_APP_HOST + "/finance/payment/bankcard_shensu",
            obj,
            true
          )
            .then((res) => {
              if (res.code == 0) {
                that.$Message.success({
                  content: res.msg,
                  duration: 3,
                });
              } else {
                that.$Message.error({
                  content: res.msg,
                  duration: 3,
                });
              }
            })
            .catch((res) => {
              console.log(res, "请求出错");
            });
        },
        onCancel: () => { },
      });
    },

    upload_before() {
      this.upload_faxin_show = true;
      return true;
    },
    upload_error(e) {
      this.upload_faxin_show = false;

      this.$Message.error('上传失败')
    },

    weituo_jiaocheng() {
      var url = "https://alidocs.dingtalk.com/i/p/7xZBGL2jAMMXL1wvrqGd9Jjnrkex3zaV";
      open_new_page(url);
    },

    shangyue() {
      var currentDate = new Date();
      var currentMonth = currentDate.getMonth();
      var currentYear = currentDate.getFullYear();
      var prevMonth, prevYear;
      if (currentMonth === 0) {
        // 一月份情况
        prevMonth = 12;
        prevYear = currentYear - 1;
      } else {
        prevMonth = currentMonth;
        prevYear = currentYear;
      }
      return [prevYear, prevMonth];
    },

    benyue() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      return [year, month];
    },

    view_bank_card_info() {
      open_new_page("/finance/payment/transition_bankcard");
    },

    view_faxinweituo_file() {
      open_new_page(
        "https://static.daxiangsys.com/dx-short-link/xls/薪资委托收款书.docx"
      );
    },

    jiezhi_hexiao_ok() { },

    zhifu_change() {
      this.get_relevance_returned_data();
      this.get_relevance_invoice_data();
    },

    // 获取关联的发票数据
    get_relevance_invoice_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/relevance_invoice_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.relevance_invoice_table_data = res.data.table_data;
            that.relevance_invoice_columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    payment_type_change(e) {
      this.bank_select = [];
      if (this.payment_type_id != "" && this.payment_type_id != null) {
        this.get_bank_options();
      }
    },

    // 项目回款表格变化
    relevance_selection_change(e) {
      console.log(e);
      this.relevance_select_list = e;
    },

    // 项目开票表格变化
    relevance_selection_invoice_change(e) {
      console.log(e);
      this.relevance_invoice_select_list = e;
    },

    // 获取关联的回款数据
    get_relevance_returned_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/relevance_returned_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.relevance_table_data = res.data.table_data;
            that.relevance_columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_record() {
      open_new_page(
        "/finance/payment/detail?project_id=" +
        this.project_id +
        "&project_name=" +
        this.project_name
      );
    },

    submit_ok() {
      // window.close();
    },

    down_file2(url) {
      open_new_page(url);
    },

    view_file2(item, i) {
      get_view_file_url(item.object_name);
    },

    view_file(object_name) {
      // var file_url =
      //   "https://kkfile.daxiangsys.com/onlinePreview?url=" +
      //   encodeURIComponent(Base64.encode(url));
      // var web_url = file_url;
      // open_new_page(web_url);
      get_view_file_url(object_name);
    },

    down_template() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/download_template",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var url = res.data.url;

            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1; // 注意月份从0开始，所以要加1
            if (month < 10) {
              var month_first = "0";
            } else {
              var month_first = "";
            }
            const date = today.getDate();
            console.log(year, month, date);
            var file_name =
              that.project_name +
              "_" +
              String(year) +
              month_first +
              String(month) +
              String(date) +
              "_发薪表";
            console.log(url);
            this.$Modal.confirm({
              title: "提示",
              content: "<p>是否要下载发薪表模板？</p>",
              onOk: () => {
                that.download_file(url, file_name);
              },
              onCancel: () => { },
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    download_file(url, name) {
      // var url = this.down_url;
      // var name = this.filename;

      fetch(url)
        .then((_) => _.blob())
        .then((_) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(_);
          link.setAttribute("download", name); // 自定义文件名
          link.click();
        });
    },

    show_faxin_jiezhi() {
      this.jiezhi_hexiao_show = true;
    },

    baocun_hexiao_btn() {
      this.faxin_file = this.jiezhi_hexiao_item;
      this.jiezhi_hexiao_show = false;
    },

    // 上传发薪表回调
    upload_faxin_success(e) {
      var that = this;
      this.upload_faxin_show = false;
      if (e.code == 0) {
        this.faxin_file = e.data;
        this.$Message.success(e.msg);
      } else {
        // 需完善已经借支数据
        if (e.code == 201) {
          this.jiezhi_hexiao_item = e.data;
          this.jiezhi_hexiao_show = true;
          this.jiezhi_hexiao_table_data = e.data.jiezhi_table_dict;
          this.$Message.info({
            content: e.msg,
            duration: 6,
          });

          // 借支未被系统自动选中的数据数量
          var jiezhi_unchecked_name_list = e.data.jiezhi_unchecked_name_list
          if (jiezhi_unchecked_name_list.length > 0) {
            this.$Modal.confirm({
              title: '发薪表借支核销有异常的提示',
              content: '<p>发薪文件上传完成，借支核销有(' + String(jiezhi_unchecked_name_list.length) + ')条金额与系统借支金额不一致，未自动勾选，不勾选会导致核销失败❌，请注意！<br> 【' + String(jiezhi_unchecked_name_list) + '】</p>',
              onOk: () => {

              },
              onCancel: () => {

              }
            });
          }
        } else {
          console.log(e.code);
          if (e.code == 414) {
            that.faxin_error_txt = e.msg;
            that.faxin_error_show = true;
            return;
          } else {
            if (e.code == 444) {
              that.faxin_error_list = e.data.return_list;
              that.faxin_error_list_show = true;
            } else {
              that.$Message.error({
                content: e.msg,
                duration: 6,
              });
            }
          }
        }
      }
    },

    del_faxin_file() {
      this.faxin_file = {};
    },

    click_jiesuan_month_btn() {
      if (this.jiesuan_year_month_status == "j1") {
        // 上月

        var currentDate = new Date();
        var currentMonth = currentDate.getMonth();
        var currentYear = currentDate.getFullYear();
        var prevMonth, prevYear;
        if (currentMonth === 0) {
          // 一月份情况
          prevMonth = 12;
          prevYear = currentYear - 1;
        } else {
          prevMonth = currentMonth;
          prevYear = currentYear;
        }
        this.ownership_date = [prevYear, prevMonth];
      }
      if (this.jiesuan_year_month_status == "j2") {
        // 本月

        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        this.ownership_date = [year, month];
      }

      if (this.jiesuan_year_month_status == "j3") {
        var jiesuan_year = this.ownership_date.getFullYear();
        var jiesuan_month = this.ownership_date.getMonth() + 1;
        this.ownership_date = [jiesuan_year, jiesuan_month];
      }
    },

    click_submit() {
      console.log(this.bank_select);

      this.click_jiesuan_month_btn();

      if (this.payment_cause_id == "") {
        this.$Message.error("请选择付款事由");
        return;
      }
      if (this.cause == "") {
        this.$Message.error("请选择付款事由");
        return;
      }
      // if (this.bank_select.length == 0) {
      //   this.$Message.error("请选择付款主体");
      //   return;
      // }
      // if (this.payment_type_id == "") {
      //   this.$Message.error("请选择付款方式");
      //   return;
      // }
      // if (this.total_money == 0) {
      //   this.$Message.error("请输入发放总金额");
      //   return;
      // }
      if (this.ownership_date == "") {
        this.$Message.error("请选择所属月份");
        return;
      } else {
        if (Array.isArray(this.ownership_date)) {
          var guishu_year = this.ownership_date[0];
          var guishu_month = this.ownership_date[1];
        } else {
          this.$Message.error("结算归属属年月出错");
          return;
        }
      }

      if (this.condition_id == "") {
        this.$Message.error("请选择支付条件");
        return;
      }

      if (this.pay_date == "") {
        this.$Message.error("请选择支付的日期");
        return;
      }
      // if (this.invoice_money == 0) {
      //   this.$Message.error("请输入对应月份（结算）开票金额");
      //   return;
      // }


      // if (JSON.stringify(this.faxin_file) == "{}") {
      //   this.$Message.error("请上传发薪表");
      //   return;
      // }

      if (this.file_list.length == 0) {
        this.$Message.error("请上传企业结算表");
        return;
      }

      // 银行id
      if (this.bank_select.length > 1) {
        var bank_id = this.bank_select[1];
      } else {
        var bank_id = "";
      }

      if (this.bank_select.length == 0) {
        this.$Message.error("请选择发薪主体");
        return;
      }

      var data = {
        project_id: this.project_id,
        project_name: this.project_name,
        cause: this.cause,
        payment_cause_id: this.payment_cause_id,
        subject_id: this.bank_select[0],
        bank_id: bank_id,

        payment_type_id: this.payment_type_id,
        total_money: this.total_money,
        // ownership_date: this.ownership_date.getTime() / 1000,
        ownership_date_year: guishu_year,
        ownership_date_month: guishu_month,
        condition_id: this.condition_id,
        relevance_select_list: this.relevance_select_list,
        convention_relevance_list: this.relevance_invoice_select_list,

        pay_date: this.pay_date.getTime() / 1000,
        invoice_money: this.invoice_money,
        faxin_file: this.faxin_file,
        img_list: this.img_list,
        file_list: this.file_list,

        // 借支勾选
        jiezhi_hexiao_table_data: this.jiezhi_hexiao_table_data,
      };
      console.log(data);
      this.submit_loading = true;
      var that = this;

      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/payment_submit",
        data,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 6,
            });
            that.submit_show = true;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 6,
            });
          }
          that.submit_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    down_file(item, i) {
      open_new_page(item.url);
    },

    del_img(item, i) {
      this.img_list.splice(i, 1);
    },

    view_img(url) {
      this.$ImagePreview.show({
        previewList: [url],
      });
    },

    del_file(item, i) {
      this.file_list.splice(i, 1);
    },

    upload_success(e) {
      console.log(e);

      if (e.code == 0) {
        this.img_list.push(e.data);
        this.$Message.success(e.msg);
      } else {
        this.$Message.error(e.msg);
        this.$refs.upload01.clearFiles();
      }
    },

    upload_file_success(e) {
      if (e.code == 0) {
        this.file_list.push(e.data);
        this.$Message.success(e.msg);
      } else {
        this.$Message.error(e.msg);
        this.$refs.upload02.clearFiles();
      }
    },

    pay_date_change(e) {
      console.log(e);
    },

    open(project_id, project_name) {
      this.project_id = project_id;
      this.project_name = project_name;
    },

    get_cause_options() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/finance/payment/payment_cause", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.cause_options = res.data.options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_bank_options() {
      var that = this;
      var obj = {
        type_id: this.payment_type_id,
      };
      http("post", process.env.VUE_APP_HOST + "/finance/payment/bank_options", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.bank_options = res.data.bank_options;
            that.payment_type_select_status = res.data.select_status;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    get_payment_type() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/finance/payment/payment_type", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.payment_options = res.data.options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    get_payment_condition() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/payment_condition",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.condition_options = res.data.options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    view_img(url) {
      this.$ImagePreview.show({
        previewList: [url],
      });
    },

    bankcard_baobei_ok() {
      var that = this;
      var obj = {
        name: this.bankcard_baobei_item.name,
        idcard: this.bankcard_baobei_item.idcard,
        bankcard_number: this.bankcard_baobei_item.bankcard_number,
        card_type: this.bankcard_baobei_item.card_type,
        project_id: this.project_id,

      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/error_bankcard_baobei",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    }
  },
};
</script>

<style scoped>
.check_jiesuan_universal_main {
  display: flex;
}

.check_jiesuan_universal {
  background-color: #fff3f3;
  border: 1px solid #ffbbbb;
  color: #636363;
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 5px;
  display: flex;
}

.check_jiesuan_universal2 {
  background-color: #f7fdf8;
  border: 1px solid rgb(120, 225, 113);
  color: #636363;
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 5px;
}

.question_yc_tag {
  font-size: 12px;
  background: #0e9f46;
  border-radius: 3px;
  padding: 3px 5px;
  color: #fff;
  font-weight: 400;
  margin-right: 10px;
}

.quesion_result_btn {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.question_result_icon {
  display: flex;
  justify-content: center;

}

.question_result_txt {
  text-align: center;
}

.question_result_icon span {
  font-size: 50px;
  color: #1ea00a
}


.question_jiexi {
  font-weight: 600;
  color: #333;
}

.analysis_result {
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
}

.question_again {
  color: #006ef5;
  margin-left: 10px;
  font-weight: 400;
  padding: 3px 10px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.question_again:hover {
  font-weight: 600;
}

.question_type {
  display: flex;
  align-items: center;
}

.question_options_div {
  display: flex;
  flex-wrap: wrap;
}

.analysis_div {
  border-top: 1px solid #ccc;
  padding-top: 5px;
}

.question_content {
  margin-top: 15px;
  border-top: 1px solid #e3e3e3;
}

.question_number {
  margin: 10px;
  display: flex;
  justify-content: flex-end;
}

.question_otpions_list {
  display: flex;
  align-items: center;
  margin: 5px 0px;
  padding: 5px 5px;
  border-radius: 5px;
  width: 50%;
}



.question_otpions_list:hover {
  background-color: #efefef;
  cursor: pointer;
}

.question_otpions_list_select {
  color: #fff;
  background-color: #1ea00a;
}

.question_otpions_list_select2 {
  color: #fff;
  background-color: #e80307;
}

.question_abc {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-right: 10px;

}

.question_name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.bank_baobei_input_div {
  margin-top: 10px;
}

.bank_baobei_input {
  margin-top: 10px;
}

.faxin_btn_list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;
}

.teaching_modal {
  height: 70vh;
  background-color: #ccc;
}

.faxin_right {
  background-color: red;
  border-left: 1px solid #ccc
}

.faxin_div {}

.faxin_div1 {
  /* width: calc(100vw - 415px); */
  /* flex-shrink: 0; */
}

.wujiezhi {
  font-size: 13px;
  display: flex;
  justify-content: center;
  color: #ededed;
  margin-bottom: 5px;
}

.shensu_msg {
  color: #0466dd;
  cursor: pointer;
  margin-left: 10px;
}

.faxin_error_list_div {
  height: 400px;
  overflow: auto;
}

.faxin_error_li {
  padding: 5px;
  border-bottom: 1px solid #ccc;
}

.options_title {
  font-weight: 600;
}

.record_options {
  padding: 10px;
  display: flex;
  margin: 10px;
  justify-content: space-between;
  background: #fff;
}

.fujian_div {
  padding: 10px;
  display: flex;
  align-items: center;
  background: #fff;
  box-shadow: 0 0 3px #ccc;
  margin-bottom: 10px;
  margin-right: 10px;
  border-radius: 5px;
}

.yewu_txt {
  color: #f60a41;
  font-weight: 300;
}

.faxin_error_img {
  width: 770px;
  height: 220px;
  cursor: pointer;
  margin-top: 10px;
  border: 1px solid #ccc;
}

.faxin_error_txt {
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
}

.index_span {
  width: 30px;
  flex-shrink: 0;
  text-align: center;
  /* background: #0466dd; */
  color: #fff;
  margin-right: 10px;
  border-radius: 10px;
}

.child_item_list {
  padding-left: 20px;
  margin-bottom: 5px;
}

.checked_jiezhi {
  display: flex;
  margin-bottom: 10px;
  margin-top: 10px;
  padding-bottom: 5px;
  align-items: center;
  color: #000
}

.checked_jiezhi_box {
  font-size: 13px;
  color: #333
}

.jiezhi_title {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  padding: 5px 0;
  background-color: #073ba5;
  color: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-top: 1px solid #e8e8e8;

}

.jiezhi_title2 {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  padding: 5px 0;
  background-color: #f60a41;
  color: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-top: 1px solid #e8e8e8;

}

.jiezhi_money {
  background: rgb(251, 138, 32);
  color: #fff;
  padding: 1px 5px;
  border-radius: 5px;
  margin-left: 10px;
}

.xzy {
  color: #fff;
  background-color: #f60a41;
  font-size: 13px;
  padding: 2px 5px;
  border-radius: 3px;
  margin-left: 10px;
}

.record_head {
  margin-right: 20px;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.record_head:hover {
  font-weight: 600;
}

.tihuan_btn {
  width: 60px;
  height: 50px;
  background: #0466dd;
  color: #fff;
  margin-left: 10px;
  border-radius: 5px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.down_upload_file {
  cursor: pointer;
}

.down_upload_file:hover {
  color: #0466dd;
}

.iconExcel {
  font-size: 35px;
  color: rgb(6, 123, 6);
}

.excel_div {
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #e9e9e9;
  height: 50px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.jiesuan_select {
  margin-top: 10px;
  margin-bottom: 8px;
  margin-left: 3px;
  padding-bottom: 15px;
}

/deep/ .down_a {
  margin: 0 10px 10px 0;
  color: rgb(68, 68, 68);
  background-color: rgb(255, 255, 255);
  border: 1px solid #ccc;
  cursor: pointer;
  padding: 5px 10px;
  font-weight: 400;
  border-radius: 5px;
  ;
}

.down_a:hover {
  opacity: .8;
}

.pagemain {
  background: #fff;
  height: 100vh;
  overflow: auto;
}

.table_hexiao_div {
  height: calc(100vh - 120px);
  overflow: auto;
}

.tijiao {
  padding: 10px;
  display: flex;
  margin: 10px;
  background: #fff;
  justify-content: flex-end;
}

.tijiao2 {
  display: flex;
  background: #fff;
  justify-content: flex-end;
}

.file_div {
  background: #ececec;
  display: flex;
  border-radius: 5px;
  overflow: hidden;
  justify-content: center;
  padding: 0 10px;
  align-items: center;
}

.down_div2 {
  height: 15px;
  width: 15px;
  background: green;
  position: absolute;
  right: 20px;
  top: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.close_div {
  height: 15px;
  width: 15px;
  background: red;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img_div_main {
  display: flex;
  margin-top: 10px;
  border-radius: 5px;
  flex-wrap: wrap;
}

.img_div {
  border-radius: 5px;
  height: 60px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  cursor: pointer;
  position: relative;
}

.faxin_tishi {
  font-size: 13px;

  color: #f60a41;
  font-weight: 300;
}

.input_div {
  padding: 20px 10px 0 10px;
  background: #fff;
  margin: 0 10px 0px 10px;
}

.input_name {
  margin-bottom: 5px;
  font-size: 13px;
  font-weight: 600;
  /* color: #333; */
  color: #0050ef
}

.logo_img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.head_title {
  cursor: pointer;
  letter-spacing: 3px;
  font-size: 14px;
  font-weight: 400;
  color: rgb(255, 255, 255);
}

.head_left {
  display: flex;
  align-items: center;
}

.head_box {
  background: rgb(79, 135, 58);
  height: 40px;
  display: flex;
  z-index: 99;
  width: 100vw;
  position: fixed;
  top: 0;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 20px;
}
</style>
